export default "__VITE_ASSET__BQLJt_3p__"